import React from 'react';
import { Emoji } from './Emoji';
export function Garantia() {
  return <section className="w-full bg-forest-900 py-16" data-id="element-107" data-mp="1x5dkn6h0phvy">
      <div className="mx-auto max-w-[680px] px-5 sm:px-8" data-id="element-108" data-mp="1x657nswju7am">
        <div className="rounded-3xl border-2 border-lime-400/40 bg-pistacho p-8 text-center sm:p-10" data-id="element-109" data-mp="224q8nujmkv04">
          <Emoji symbol="🛡️" className="mx-auto block text-5xl" data-id="element-110" data-mp="2742s05bafjxy" />
          <h2 className="mt-5 font-display text-2xl font-extrabold uppercase tracking-tight text-forest-950 sm:text-3xl" data-id="element-111" data-mp="2716tofvj2t8z">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[15px] leading-relaxed text-forest-800" data-id="element-112" data-mp="2g2escz1yhw3l">
            Descargás los tomos. Los usás en tu cocina. Si en 7 días no es
            exactamente lo que esperabas, escribís a{' '}
            <a href="mailto:closethegap14@gmail.com" className="font-semibold text-lime-700 underline underline-offset-2" data-id="element-113" data-mp="2ut4545v2fj9k">
              closethegap14@gmail.com
            </a>{' '}
            y te devolvemos el{' '}
            <strong className="font-bold text-forest-950" data-id="element-114" data-mp="3fnal8r61fwx3">
              100% de tu dinero
            </strong>
            . Sin formularios. Sin drama. Sin explicaciones.
          </p>
          <p className="mt-4 text-sm font-bold text-lime-700" data-id="element-115" data-mp="35ol08piuhwcm">
            Tasa de devoluciones: menos del 1%.
          </p>
          <p className="mx-auto mt-4 max-w-lg text-sm text-forest-600/85" data-id="element-116" data-mp="30q9ryj877twi">
            Podemos ofrecer esta garantía porque sabemos lo que el sistema hace
            cuando alguien realmente lo usa.
          </p>
        </div>
      </div>
    </section>;
}